import { CheckSmall } from "@components/Icons"
import { Box } from "@components/Layout"
import React from "react"
import * as S from "./elements"

type Item = {
  value: string
  label: string
}

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  items: Item[]
}

export const RadioButtons: React.FC<Props> = ({
  items,
  value,
  name,
  ...rest
}) => (
  <Box display="flex" width="100%">
    {items.map((item) => (
      <S.RadioButton key={item.value}>
        <input
          checked={value === item.value}
          type="radio"
          id={item.value}
          name={name}
          {...rest}
        />
        <S.CheckContainer>
          <CheckSmall />
        </S.CheckContainer>
        <S.Label htmlFor={item.value}>{item.label}</S.Label>
      </S.RadioButton>
    ))}
  </Box>
)
